import { useEffect, useState, useCallback } from 'react'
import { Col, Row } from 'reactstrap'

import './standardrapporterSide.css'
import { setValgtSide } from '../../actions'
import { STANDARDRAPPORTER_INFO, STANDARDRAPPORTER_OVERSKRIFT } from '../../ressurser/Konstanter'
import Tilbakeknapp from '../uukomponenter/Tilbakeknapp'

import { useDispatch } from 'react-redux'

import arsrapporter from './rapportlister/rapportconfig/arsrapporter'
import enhetsrapporter from './rapportlister/rapportconfig/enhetsrapporter'
import stedsforholdrapporter from './rapportlister/rapportconfig/stedsforholdrapporter'
import temarapporter from './rapportlister/rapportconfig/temarapporter'
import ulykkestyperapporter from './rapportlister/rapportconfig/ulykkestyperapporter'
import Rapportliste from './rapportlister/Rapportliste'
import Rapportsok from './Rapportsok'

const StandardrapporterSide = () => {
    const [sokUtfort, setSokUtfort] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        document.title = 'Standardrapporter | Trine'
        dispatch(setValgtSide('standardrapporter'))
    })

    const fokuserOverskrift = useCallback((overskriftElement) => {
        if (overskriftElement) {
            overskriftElement.focus()
        }
    })

    return (
        <>
            <div>
                <Tilbakeknapp />
            </div>
            <div>
                <Row>
                    <Col xl={{ size: '12' }} lg={{ size: '8' }} md={{ size: '8' }}>
                        <h1 tabIndex="-1" ref={fokuserOverskrift} className="standardrapporteroverskrift">
                            {STANDARDRAPPORTER_OVERSKRIFT}
                        </h1>
                        <p>{STANDARDRAPPORTER_INFO}</p>
                    </Col>
                </Row>
                <Row className="m-4">
                    <Col xl={3} className="velg-ar-og-fylke-konteiner">
                        <Rapportsok sokUtfort={sokUtfort} setSokUtfort={(e) => setSokUtfort(e)} />
                    </Col>
                    <Col xl={9}>
                        <Row>
                            <Rapportliste overskrift="Årsrapporter" rapportliste={arsrapporter} sokUtfort={sokUtfort} />
                            <Rapportliste
                                overskrift="Rapporter enhetsgrupper"
                                rapportliste={enhetsrapporter}
                                sokUtfort={sokUtfort}
                            />
                            <Rapportliste
                                overskrift="Rapporter stedsforhold og strekninger"
                                rapportliste={stedsforholdrapporter}
                                sokUtfort={sokUtfort}
                            />
                        </Row>
                        <Row>
                            <Rapportliste
                                overskrift="Rapporter ulykkestyper"
                                rapportliste={ulykkestyperapporter}
                                sokUtfort={sokUtfort}
                            />
                            <Rapportliste overskrift="Andre temarapporter" rapportliste={temarapporter} sokUtfort={sokUtfort} />
                        </Row>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default StandardrapporterSide
